export function formatClassNames(string) {
  return String(string).split(',').map(name => name.trim().toLowerCase().replace(/_+/g, '').replace(/\s+/g, '-')).join(' ')
}

export async function asyncFetchJSON(url) {
  const options = window.location.hostname === 'localhost' ? {} : {headers: {'Cache-Control': 'no-cache'}}
  try {
    let response = await fetch(url, options)
    if (response.ok) return await response.json()
  } catch(err) {
    console.warn(`>> could not fetch resource, ${navigator.onLine ? 'online' : 'offline'}, ${err}`);
  }
}

export async function asyncFetchBuffer(url) {
  const options = window.location.hostname === 'localhost' ? {} : {headers: {'Cache-Control': 'no-cache'}}
  try {
    let response = await fetch(url, options)
    if (response.ok) return await response.arrayBuffer()
  } catch(err) {
    console.warn(`>> could not fetch resource, ${navigator.onLine ? 'online' : 'offline'}, ${err}`);
  }
}

const asyncLocalStorage = {
    setItem: function (key, value) {
        return Promise.resolve().then(function () {
            localStorage.setItem(key, value);
        });
    },
    getItem: function (key) {
        return Promise.resolve().then(function () {
            return localStorage.getItem(key);
        });
    }
};

function isValidPort(portName) {
  return portName === 'K-Board';
}

export { asyncLocalStorage, isValidPort }
